window.addEventListener("resize", (event) => {
  if (window.innerWidth >= 1140) {
    document.querySelector(".Header__MainNav").style.position = "absolute";
    document.querySelector(".Header__MainNav").style.display = "flex";
    document.querySelector(".Header__MainNav").style.bottom = "0";
    document.querySelector(".Header__MainNav").style.left = "0";
    document.querySelector(".Header__MainNav").style.paddingBottom = "8px";
    document.querySelector(".Header__MainNav").style.paddingTop = "8px";
    document.querySelector(".Header__MainNav").style.textAlign = "center";
    document.querySelector(".Header__MainNav").style.width = "100%";
    document.querySelector(".Header__MainNav").style.justifyContent = "center";
    //document.querySelector(".Header__MainNav").style.boxShadow =
    //  "0px 0px 2px 0px #222";
    document.querySelector(".Header__MainNav").style.marginRight = "45px";
    document.querySelector("#shopify-section-header").style.height = "112.5px";
  } else {
    document.querySelector("#shopify-section-header").style.height = "auto";
    document.querySelector(".Header__MainNav").style.display = "none";
  }
});
// Cart get it by date js code

// Resilient cart delivery date logic: expose a function and re-run when cart drawer/snippet is re-rendered
(function () {
  const DELIVERY_DAYS = 12;

  function addBusinessDays(date, days) {
    const result = new Date(date);
    while (days > 0) {
      result.setDate(result.getDate() + 1);
      const dayOfWeek = result.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        days--;
      }
    }
    return result;
  }

  function formatEstimatedDate(dateObj) {
    const months = [
      "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"
    ];
    const daysShort = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];
    return `${dateObj.getDate()}. ${months[dateObj.getMonth()]} `;
  }

  function setCartDeliveryDate() {
    try {
      const el = document.getElementById("cart-deliverydate");
      if (!el) return false;
      const now = new Date();
      const estimated = addBusinessDays(now, DELIVERY_DAYS);
      el.textContent = formatEstimatedDate(estimated);
      // el.textContent = "Christmas";
      return true;
    } catch (e) {
      // swallow errors to avoid breaking other scripts
      console.error("setCartDeliveryDate error", e);
      return false;
    }
  }

  // Run on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setCartDeliveryDate);
  } else {
    setCartDeliveryDate();
  }

  // Debounce helper
  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }

  const debouncedSetter = debounce(setCartDeliveryDate, 100);

  // Observe changes to the cart drawer container and re-run when innerHTML changes
  const cartDrawerSelector = "#sidebar-cart";
  const observeTarget = document.body;

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      // look for added/changed nodes that contain our cart drawer or the target element
      if (m.addedNodes && m.addedNodes.length) {
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          if (node.matches && node.matches(cartDrawerSelector)) {
            debouncedSetter();
            return;
          }
          if (node.querySelector && node.querySelector("#cart-deliverydate")) {
            debouncedSetter();
            return;
          }
        }
      }

      if (m.type === "childList" && m.target instanceof HTMLElement) {
        if (m.target.matches && m.target.matches(cartDrawerSelector)) {
          debouncedSetter();
          return;
        }
        if (
          m.target.querySelector &&
          m.target.querySelector("#cart-deliverydate")
        ) {
          debouncedSetter();
          return;
        }
      }
    }
  });

  mo.observe(observeTarget, { childList: true, subtree: true });

  // Also listen for common cart update events from themes/apps
  // const events = [
  //   "cart:updated",
  //   "cart:refresh",
  //   "ajaxCart.update",
  //   "cart:update",
  //   "cart.changed",
  // ];
  // events.forEach((ev) => document.addEventListener(ev, debouncedSetter));

  // Expose for manual re-run if needed
  window.setCartDeliveryDate = setCartDeliveryDate;
})();

//

document.addEventListener("click", function (e) {
  // Apply discount
  if (e.target && e.target.id === "cart-discount-apply") {
    var input = document.getElementById("cart-discount-input");
    var error = document.getElementById("cartDiscountError");
    var errorCode = document.getElementById("cartDiscountErrorDiscountCode");
    // var errorShipping = document.getElementById("cartDiscountErrorShipping");
    error.classList.add("hidden");
    errorCode.classList.add("hidden");
    // errorShipping.classList.add("hidden");
    var code = input.value.trim();
    if (!code) return;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: code }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        // Determine whether discount was actually applied.
        var applied = false;

        // If the response contains an HTTP-like status error, treat as not applied
        if (data && data.status && data.status !== 200) {
          applied = false;
        } else if (
          data &&
          Array.isArray(data.discount_codes) &&
          data.discount_codes.length
        ) {
          // Look for the attempted code in returned discount_codes (case-insensitive)
          var found = data.discount_codes.find(function (dc) {
            return (
              dc &&
              dc.code &&
              dc.code.toString().toLowerCase() === code.toLowerCase()
            );
          });
          if (found) {
            applied = !!found.applicable;
          } else {
            // fallback: consider total_discount if code not listed
            applied = !!(data.total_discount && data.total_discount > 0);
          }
        } else {
          // fallback: use total_discount as indicator
          applied = !!(data && data.total_discount && data.total_discount > 0);
        }

        if (!applied) {
          // show invalid code error
          error.classList.remove("hidden");
          errorCode.classList.remove("hidden");
          input.value = "";
          return;
        }

        // success: refresh cart UI
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          }),
        );
        // window.location.reload();
      })
      .catch(function () {
        error.classList.remove("hidden");
        errorCode.classList.remove("hidden");
      });
  }

  // Remove discount
  if (e.target && e.target.classList.contains("cart-discount__remove")) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ discount: "" }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          }),
        );
        // window.location.reload();
      });
  }
});
